import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../../context";
import {
  navAvatarAreaLinks,
  navLinks,
} from "../../../config/navlinks/dashboard";
import { BaseButton } from "../../button/styled";
import { P, Span } from "../../typography/styled";
import { SideNavigationWrapper } from "./styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretDown,
  faCaretRight,
  faPlus,
  faXmark,
  faGrip,
  faUsers,
  faFileInvoiceDollar,
  faBuilding,
  faChartBar,
  faGears,
  faUser,
  faLock,
  faHandshake,
  faTag,
  faCreditCard,
  faArrowUpFromBracket,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";
import { Avatar, LogoII } from "../../../assets";
import { Column, Row } from "../../flex/styled";
import { Link, NavLink, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { getCompanies } from "../../../utils/apis/company/getCompanies";
import { getUser } from "../../../utils/apis/user/getUser";
import sessionCache from "../../../utils/sessionCache";

const iconMap = {
  faGrip,
  faUsers,
  faFileInvoiceDollar,
  faBuilding,
  faChartBar,
  faGears,
  faUser,
  faLock,
  faHandshake,
  faTag,
  faCreditCard,
  faWallet,
};

export const SideNavigation = ({
  location,
  callToAction,
  handleCallToActionClick,
  bulkCallToAction,
  handleBulkCallToActionClick,
}) => {
  const cookie = new Cookies();
  const { ROLE, TOKEN } = cookie.getAll() ?? {};

  const navigate = useNavigate();
  const {
    setIsSideNavigationOpen,
    setIsResetPasswordModalOpen,
    activeCompanyId,
    setActiveCompanyId,
    activeCompanyDetails,
    setActiveCompanyDetails,
  } = useContext(Context);

  const [matches, setMatches] = useState(false);
  const [isUserProfileDropdownOpen, setIsUserProfileDropdownOpen] =
    useState(false);
  const [userCompanies, setUserCompanies] = useState(
    () => sessionCache.get("userCompanies") || []
  );
  // const [activeCompanyId, setActiveCompanyId] = useState(COMPANY_ID);
  const [isUserCompaniesDropdownOpen, setIsUserCompaniesDropdownOpen] =
    useState(false);
  const [isSubItemsOpen, setIsSubItemsOpen] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState(
    () => sessionCache.get("loggedInUser") || {}
  );
  const [activeActionMenuIndex, setActiveActionMenuIndex] = useState(null);
  const actionMenuRef = useRef(null);
  const callToActionItems = Array.isArray(callToAction)
    ? callToAction
    : callToAction
      ? [
        {
          label: callToAction,
          icon: faPlus,
          onClick: handleCallToActionClick,
        },
        ...(bulkCallToAction
          ? [
            {
              label: bulkCallToAction,
              icon: faArrowUpFromBracket,
              onClick: handleBulkCallToActionClick,
            },
          ]
          : []),
      ]
      : [];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        actionMenuRef.current &&
        !actionMenuRef.current.contains(event.target)
      ) {
        setActiveActionMenuIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogoClick = (e) => {
    e.preventDefault();
    return navigate("/dashboard");
  };

  const handleSideNavItemClick = (e, destination) => {
    e.preventDefault();
    e.stopPropagation();
    if (destination === "/reportsummary") {
      return setIsSubItemsOpen(!isSubItemsOpen);
    }
    if (destination === "/resetpassword") {
      matches && setIsSideNavigationOpen(false);
      return setIsResetPasswordModalOpen(true);
    }
    matches && setIsSideNavigationOpen(false);
    return navigate(destination);
  };

  const handleNavAvatarAreaLinkClick = async (e, destination) => {
    e.preventDefault();
    e.stopPropagation();
    if (destination === "/switchcompany") {
      return setIsUserCompaniesDropdownOpen(!isUserCompaniesDropdownOpen);
    }
    if (destination === "/") {
      await cookie.remove("ROLE", { path: "/" });
      await cookie.remove("COMPANY_ID", { path: "/" });
      await cookie.remove("TOKEN", { path: "/" });
      // Wipe the session-storage cache so stale data isn't served to the
      // next user who logs in on the same browser tab.
      sessionCache.clear();
      // Also reset the in-memory React context state; sessionCache.clear()
      // only wipes storage — the context values survive until the component
      // tree remounts, which it won't if the user logs straight back in.
      setActiveCompanyId(null);
      setActiveCompanyDetails(null);
    }
    return navigate(`${destination}`);
  };

  const handleUserProfileIconClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsUserCompaniesDropdownOpen(false);
    return setIsUserProfileDropdownOpen(!isUserProfileDropdownOpen);
  };

  const handleActiveCompanyUpdate = (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    cookie.set("COMPANY_ID", id, {
      path: "/",
      maxAge: 1000000,
    });
    setActiveCompanyId(id);
    setIsUserCompaniesDropdownOpen(false);
    navigate("/dashboard");
  };

  useEffect(() => {
    getUser(TOKEN)
      .then((data) => {
        setLoggedInUser(data);
        sessionCache.set("loggedInUser", data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [TOKEN]);

  useEffect(() => {
    if (ROLE !== "employer") return;
    getCompanies(TOKEN)
      .then((data) => {
        setUserCompanies(data);
        sessionCache.set("userCompanies", data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [TOKEN, ROLE]);

  useEffect(() => {
    const handleResize = () => {
      setMatches(window.screen.availWidth < 1024);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <SideNavigationWrapper USERROLE={ROLE} location={location}>
      <div className="side-navigation-upper-section">
        <div className="nav-logo">
          <div className="logo-box-area" onClick={handleLogoClick}>
            <LogoII />
          </div>
          <BaseButton onClick={() => setIsSideNavigationOpen(false)}>
            <FontAwesomeIcon icon={faXmark} color="#FFFFFF" />
          </BaseButton>
        </div>
        {ROLE === "employer" && (
          <div className="switch-companies-box">
            <div>
              <Link
                onClick={(e) =>
                  handleNavAvatarAreaLinkClick(e, "/switchcompany")
                }
              >
                <Row alignitems={"center"} justifycontent={"space-between"}>
                  <P>Switch Company</P>
                  <FontAwesomeIcon
                    icon={
                      isUserCompaniesDropdownOpen ? faCaretDown : faCaretRight
                    }
                  />
                </Row>
              </Link>
            </div>
            {isUserCompaniesDropdownOpen && (
              <ul className="sub-items user-companies-dropdown">
                {userCompanies?.map((company, index) => {
                  return (
                    <li key={index}>
                      <P
                        onClick={(e) =>
                          handleActiveCompanyUpdate(e, company.companyId)
                        }
                        className={
                          activeCompanyId === company.companyId
                            ? "active-company"
                            : "inactive-company"
                        }
                      >
                        {company.name}
                      </P>
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
        )}
      </div>
      <Column className="nav-links">
        {navLinks[ROLE]?.filter(navLink => {
          if (navLink.name === "Wallet" && activeCompanyDetails?.payrollPlan?.toLowerCase() !== "premium") {
            return false;
          }
          return true;
        }).map((navLink, index) => {
          return (
            <Fragment key={index}>
              <NavLink
                className={navLink.name === "Payroll Setup" ? "setup" : null}
                to={navLink.url}
                onClick={(e) => handleSideNavItemClick(e, navLink.url)}
              >
                {navLink.name === "Report Summary" ? (
                  <Row alignitems={"center"} justifycontent={"space-between"}>
                    <Row alignitems={"center"} gap={"1rem"}>
                      {navLink.icon && (
                        <FontAwesomeIcon icon={iconMap[navLink.icon]} />
                      )}
                      <P>{navLink.name}</P>
                    </Row>
                    <FontAwesomeIcon
                      icon={isSubItemsOpen ? faCaretDown : faCaretRight}
                    />
                  </Row>
                ) : (
                  <Row alignitems={"center"} gap={"1rem"}>
                    {navLink.icon && (
                      <FontAwesomeIcon icon={iconMap[navLink.icon]} />
                    )}
                    <P>{navLink.name}</P>
                  </Row>
                )}
              </NavLink>
              {navLink.name === "Report Summary" && isSubItemsOpen && (
                <ul className="sub-items">
                  {navLink?.subItems?.map((subItem, index) => {
                    return (
                      <li key={index}>
                        <Link to={subItem.url}>
                          <P>{subItem.name}</P>
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              )}
            </Fragment>
          );
        })}
      </Column>
      {callToActionItems.length > 0 && (
        <Row className="call-to-action-buttons">
          {callToActionItems.map((actionItem, index) => {
            const hasMenu = actionItem?.menuItems?.length > 0;

            return (
              <div
                key={`${actionItem?.label || "action"}-${index}`}
                className="nav-action-item"
                ref={
                  hasMenu && activeActionMenuIndex === index
                    ? actionMenuRef
                    : null
                }
              >
                <BaseButton
                  className="nav-action-button"
                  onClick={(e) => {
                    if (hasMenu) {
                      e.stopPropagation();
                      setActiveActionMenuIndex((currentIndex) =>
                        currentIndex === index ? null : index,
                      );
                      return;
                    }

                    setIsSideNavigationOpen(false);
                    return actionItem?.onClick?.(e);
                  }}
                >
                  <FontAwesomeIcon
                    icon={actionItem?.icon || faPlus}
                    color="#448DEF"
                  />
                  <Span>{actionItem?.label ?? "Add Employee"}</Span>
                  {hasMenu && (
                    <FontAwesomeIcon
                      icon={faCaretDown}
                      color="#448DEF"
                      className="action-caret"
                    />
                  )}
                </BaseButton>

                {hasMenu && activeActionMenuIndex === index && (
                  <ul className="action-dropdown">
                    {actionItem.menuItems.map((menuItem, menuIndex) => (
                      <li key={`${menuItem?.label || "menu"}-${menuIndex}`}>
                        <button
                          type="button"
                          onClick={(e) => {
                            setIsSideNavigationOpen(false);
                            menuItem?.onClick?.(e);
                            setActiveActionMenuIndex(null);
                          }}
                        >
                          {menuItem?.label}
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            );
          })}
        </Row>
      )}
      <Column className="nav-avatar-area">
        <Row
          alignitems={"center"}
          gap={"calc(var(--flexGap)/4)"}
          justifycontent={"space-between"}
          onClick={handleUserProfileIconClick}
          style={{ cursor: "pointer" }}
        >
          <Avatar />
          {ROLE !== "admin" ? (
            <Span>
              {" "}
              {loggedInUser?.fullName
                ?.split(" ")[1]
                .replace(/\b\w/g, (char) => char.toUpperCase())}
            </Span>
          ) : (
            <Span>Admin</Span>
          )}
          <FontAwesomeIcon
            icon={isUserProfileDropdownOpen ? faCaretDown : faCaretRight}
          />
        </Row>
        {isUserProfileDropdownOpen && (
          <ul className="sub-items">
            {navAvatarAreaLinks?.[ROLE]?.map((subItem, index) => {
              return (
                <li key={index}>
                  <Link
                    onClick={(e) =>
                      handleNavAvatarAreaLinkClick(e, subItem.url)
                    }
                  >
                    <P>{subItem.name}</P>
                  </Link>
                </li>
              );
            })}
          </ul>
        )}
      </Column>
    </SideNavigationWrapper>
  );
};
